import { all } from 'redux-saga/effects';
import { fillOrderSaga } from './order/sagas';
import { saveServicesSaga, watchExternalActionsSaga } from './selectedServices/sagas';
export default function* rootSaga() {
    yield all([fillOrderSaga(), saveServicesSaga(), watchExternalActionsSaga()]);
}
